module.exports = __webpack_public_path__ + "static/img/Z37_01.d24ce0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Z37_01.png
// module id = 7WWx
// module chunks = 4